import axios from "axios";
import { sessionExpired } from "../lib/sessionExpired";

let getToken = () => null; // Default, will be set by app

export const setTokenGetter = (getter) => {
  getToken = getter;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: "https://staging.ginox.io",
  headers: {
    "Content-Type": "application/json",
  },
});


instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// A dead token ends the session. Login, 2FA verify and reset-password live under
// /api/admin/auth/ and are skipped: an expired 2FA tempToken is a 401 the form must show.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.url?.startsWith("/api/admin/auth/")
    ) {
      sessionExpired();
    }
    return Promise.reject(error);
  }
);

export default instance;
